import React from 'react'
import { PayrollWorkerWithWeeksSummary } from '../../../hooks/payroll'
import { WorkPeriodEvent } from '../../../api/work-period-events'

/**
 * Interface pour standardiser les valeurs de cellules du tableau
 * Évite la duplication de code dans les Cell renderers
 */
export interface CellValue {
  /** Valeur principale à afficher */
  value: string
  /** Valeur décimale optionnelle (affichée en petit et gris) */
  decimal?: string
  /** Indique si la valeur doit être affichée comme "N/A" en gris */
  isNA?: boolean
  /** Couleur de la cellule */
  color?: 'success' | 'warning' | 'danger'
}

/**
 * Props pour le composant PayrollWeeksTable
 */
export interface PayrollWeeksTableProps {
  /** Worker sélectionné avec ses données */
  worker: PayrollWorkerWithWeeksSummary
  /** Liste des semaines à afficher */
  weeks: Date[]
  /** Liste des work period events */
  events: WorkPeriodEvent[]
  /** Callback parent pour ouvrir la modale de clôture */
  onCloseWeek?: (weekNumber: number, year: number) => void
}

/**
 * Interface pour les données d'une ligne de semaine
 */
export interface WeekRowData {
  weekNumber: string
  year: string
  weekNumberValue?: number
  yearValue?: number
  weekStart: string
  weekEnd: string
  weekStartDate: Date | undefined
  weekEndDate: Date | undefined
  workerId: string

  // Nouvelles structures CellValue pour éviter la duplication dans les Cell renderers
  /** Heures contractuelles */
  contractHours: CellValue
  /** Heures travaillées */
  worked: CellValue
  /** Heures non effectives (congés, maladies, etc.) */
  nonEffective: CellValue
  /** Heures comptabilisées */
  accounted: CellValue
  /** Heures envoyées aux compteurs */
  sentToCounters: CellValue

  // Structures CellValue pour les écarts
  /** Écart entre heures travaillées et contractuelles */
  contractDiff: CellValue
  /** Écart entre heures travaillées et contractuelles (format décimal) */
  contractDiffDecimal: CellValue

  // Composants React complexes (gardés en ReactNode)
  informativeEvents?: React.ReactNode

  /** Tooltip avec répartition détaillée par compteur */
  accountedSentToCountersTooltip?: React.ReactNode

  // États de la semaine
  isRecorded: boolean
  isValidated: boolean
  isTotalRow: boolean

  // Employer rules et events (index signature pour flexibilité)
  [key: string]: React.ReactNode | string | number | boolean | Date | CellValue
}
